module.exports = __webpack_public_path__ + "static/media/mahindra.2862dea5.png";